import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium'
import { Link } from 'react-router'
import { semanticColors } from '../../../Globals/styles';
import Map from './map';

/*cant style Link workaround
https://github.com/reactjs/react-router/issues/1568*/
var RadiumLink = Radium(Link)

class Front extends Component {
  updateFavorite = () => {
    this.props.updateFavorite(!this.props.favorite);
  };

  render() {
    const { projectId, projectName, projectNumber, client, showBack } = this.props;
    //TODO use defaultProps instead
    var location = { address: '', lng: '', lat: '' };
    if (this.props.location) { location = { ...this.props.location } }
    var starclass = this.props.favorite ? "fa fa-star" : "fa fa-star-o"

    return (
      <div style={styles.body} id={projectId + 'bodyfront'}>
        <i className={starclass}
          style={styles.defaultStar}
          onClick={this.updateFavorite}
        />
        <RadiumLink
          to={"/tilbud/sag/" + projectNumber}
          style={styles.title}
        >
          <div className="btn btn-primary waves-btn" style={styles.cardHeader}>
            <div>{projectName}</div>
          </div>
        </RadiumLink>
        <div className="col-xs-12" style={styles.cardBody} >
          <div className="row">
            {/* <Map
            style={styles.map}
            lat={location.lat}
            lng={location.lng}
          /> */}
            <div style={styles.address}>
              <h3 style={styles.h3}> Adresse </h3>
              <div> {location.address} </div>
            </div>
          </div>
          <div className="row">
            <div style={styles.h3} className="col-xs-6">
              <h3>Sagsnummer</h3>
              <div>{projectNumber}</div>
            </div>
            <div style={styles.h3} className="col-xs-6">
              <h3>Bygherre</h3>
              <div>{client}</div>
            </div>
          </div>
          <div
            onClick={showBack}
            style={styles.flipCardButton}>
            <div
              className="waves-btn"> Kontakt
          <i className="fa fa-chevron-right" style={styles.i} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

var styles = {
  body: {
    fontSize: '14px'
  },
  rows: {
    position: 'relative',
    marginTop: '10px'
  },
  cardHeader: {
    height: '150px',
    width: '100%',
    borderTopLeftRadius: '2px',
    borderTopRightRadius: '2px',
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
    lineHeight: '150px',
    fontSize: '20px',
    fontWeight: 'bold',
    ':hover': {
      backgroundColor: semanticColors.primaryDark
    }
  },
  cardBody: {
    backgroundColor: semanticColors.default,
    textAlign: 'center',
    height: '455px',
    borderBottomLeftRadius: '2px',
    borderBottomRightRadius: '2px'
  },
  address: {
    color: semanticColors.default,
    height: '65px',
    width: '100%',
    backgroundColor: semanticColors.primary,
    opacity: '0.75',
    position: 'absolute',
    top: '186px',
    textAlign: 'left',
    paddingLeft: '12px'
  },
  flipCardButton: {
    position: 'absolute',
    bottom: '30px',
    right: '12px',
    fontWeight: '600',
    textAlign: 'right',
    cursor: 'pointer'
  },
  i: {
    marginLeft: '5px'
  },
  title: {
    fontSize: '20px',
    color: semanticColors.default,
    fontWeight: 'bold',
    textDecoration: 'none'
  },
  h3: {
    textAlign: 'left',
    marginTop: '12px'
  },
  defaultStar: {
    position: 'absolute',
    top: '0px',
    right: '0px',
    zIndex: '2',
    fontSize: '20px',
    color: semanticColors.default,
    cursor: 'pointer',
    width: '40px',
    height: '40px',
    lineHeight: '40px',
    textAlign: 'center'
  }
}
Front.propTypes = {
  projectName: PropTypes.string.isRequired,
  projectNumber: PropTypes.string.isRequired,
  projectId: PropTypes.string.isRequired,
  client: PropTypes.string,
  location: PropTypes.shape({
    address: PropTypes.string,
    lng: PropTypes.string,
    lat: PropTypes.string
  }),
  favorite: PropTypes.bool.isRequired
};

export default Radium(Front);



// WEBPACK FOOTER //
// ./src/App/Project/Dashboard/ProjectCard/front.jsx